import { Form } from "antd";
import { HeaderOverview, IRenderBarChart, RenderBarChart } from "components";
import dayjs from "config/dayjs";
import { APPLICATION_MENUS } from "menus/application";
import { MAIN_MENUS } from "menus/main";
import { PROPERTY_MENUS } from "menus/property";
import {
  ErrorDashboard,
  LoadingDashboard,
  NoDataDashboard,
  Wrapper,
  checkDataObject,
} from "pages/overview";
import { useAppLanguage } from "providers/app-language";
import { useOverview } from "providers/overview";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useGetDashboardGraph } from "service/dashboard/central/overview";
import { IDashboardGraph } from "service/dashboard/central/overview/interface";
import { IData } from "service/dashboard/interface";

const colors = [
  "#7986CB",
  "#3F51B5",
  "#4285F4",
  "#33B679",
  "#0B8043",
  "#C0CA33",
  "#F6BF26",
  "#F09300",
  "#EF6C00",
  "#D50000",
  "#D81B60",
  "#E67C73",
  "#7986CB",
  "#3F51B5",
];

const ListMenus = () => {
  const { t } = useTranslation();
  const { findDate, property } = useOverview();
  const listMenusDate = Form.useWatch("listMenusDate");
  const date = findDate(listMenusDate, "month");
  const [getData, setGetData] = useState<IData[]>([]);
  const { formatDate } = useAppLanguage();
  const { data, isFetching, isError, error } = useGetDashboardGraph({
    property,
    ...date,
    enabled: !!property,
  });
  const findNoCount = getData.some((e) => e.count > 0);

  const calculatedYesterday = dayjs().subtract(1, "day");

  const dataBar: IRenderBarChart = {
    data: getData,
    dataKeyX: "title",
    dataKeyY: "count",
    color: "#F6BF26",
    colorsBar: colors,
    isMenu:true,
  };

  useEffect(() => {
    if (data) {
      const findData = checkDataObject(data);
      const getMapData: IData[] =
        findData?.map((e: IDashboardGraph) => {
          const menus = [
            ...MAIN_MENUS,
            ...PROPERTY_MENUS,
            ...APPLICATION_MENUS,
          ];
          const menu = menus.find((menu) => menu.code === e.menuCode);
          const title = menu ? t(menu.title, { ns: "menu" }) : "";
          return { count: e.totalClickerByMenu, title };
        }) || [];
      setGetData(getMapData);
    }
  }, [data]);


  return (
    <Wrapper className="h-[400px]">
      <LoadingDashboard loading={isFetching}>
        <HeaderOverview
          title={t("menu-item")}
          name="listMenusDate"
          subTitle={`${t("last_updated_on")} ${formatDate({
            date: calculatedYesterday,
            format: "normal",
          })}`}
        />
        {isError ? (
          <ErrorDashboard error={error} height="300px" />
        ) : !data || data.length <= 0 || !findNoCount ? (
          <NoDataDashboard height="300px" />
        ) : (
          <RenderBarChart {...dataBar} />
        )}
      </LoadingDashboard>
    </Wrapper>
  );
};

export default ListMenus;
